import { FC } from "react";

import { Box } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";

import { AutomatedCommunicationCard } from ".././components/AutomatedCommunicationCard";
import { SendAutomatedEmailTestButton } from "../components/SendAutomatedEmailTestButton";
import { SmsOptInConfirmation } from "../helpers/useSmsOptInConfirmation";
import { AutomatedCommunicationsFormData, RowKey } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";

interface OutbidCardProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  isSmsEnabled: boolean;
  smsOptIn: SmsOptInConfirmation;
}

export const OutbidCard: FC<OutbidCardProps> = ({ openRow, onToggleOpen, isSmsEnabled, smsOptIn }) => {
  const { t } = useTranslate();
  const form = useFormContext<AutomatedCommunicationsFormData>();
  const outbidSmsEnabled = useWatch({ control: form.control, name: "outbid.smsEnabled" });

  return (
    <AutomatedCommunicationCard<AutomatedCommunicationsFormData>
      label={t("dashboard", "ticketing.automatedCommunications.row.outbid.label")}
      control={form.control}
      errors={form.formState.errors}
      dataEmailType="outbid"
      fields={{ content: "outbid.smsEnabled" }}
      enabled
      lockedOn
      chip={{
        label: t("dashboard", "ticketing.automatedCommunications.trigger.whenOutbid"),
        showWhen: "enabled",
      }}
      collapse={{ isOpen: openRow === "outbid", onToggle: () => onToggleOpen("outbid") }}
      channelIcons={isSmsEnabled ? { email: true, sms: outbidSmsEnabled } : undefined}
      channelSelectors={
        isSmsEnabled
          ? {
              email: { checked: true, locked: true },
              sms: {
                checked: outbidSmsEnabled,
                onChange: smsOptIn.guardSetSmsEnabled((value) =>
                  form.setValue("outbid.smsEnabled", value, { shouldDirty: true })
                ),
              },
            }
          : undefined
      }
      transactionalNotice
      dataTestPrefix="outbid"
      footnote={
        <Box marginTop={2} display="flex" justifyContent="flex-start">
          <SendAutomatedEmailTestButton<AutomatedCommunicationsFormData> emailType="auction-outbid" />
        </Box>
      }
    />
  );
};
